// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'Assets/theme/index.css';
import Vue from 'vue';
import ElementUI from 'element-ui';
// import VueCodemirror from 'vue-codemirror';
// import ScrollsPy from 'vue2-scrollspy';
import ScrollsPy from 'vue2-scrollspy/dist/index';
import VueQrCode from '@xkeshi/vue-qrcode';

import waterfall from 'vue-waterfall2';
// eslint-disable-next-line
// import $ from 'expose-loader?$!jquery';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'animate.css';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'codemirror/lib/codemirror.css';
import 'Assets/scss/reset.scss';
import 'Assets/scss/global.scss';
import 'Assets/scss/_mixins.scss';
import 'Assets/scss/_variables.scss';
import 'Assets/scss/_functions.scss';
import 'Assets/iconfont/iconfont.css';
import 'Assets/iconfont/new-ui/iconfont.css';
import 'Assets/D-DIN/D-DIN.css';
import 'Assets/PingFang SC/PingFang SC.css';
// import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import ba from 'vue-ba';
import Plugin from 'Utils/plugin';
import Print from 'Utils/print'; // 引入打印的js文件
import interceptors from 'Api/interceptors';
import Request from 'Api/request';
import i18n from './i18n/i18n';
import router from './router';
import store from './store';
import App from './App';

Vue.use(ElementUI);
Vue.use(Plugin);
Vue.use(Print);
// Vue.use(VueCodemirror);
// use default options
Vue.use(ScrollsPy);
Vue.use(waterfall);
/* Vue.use(ba, '034386b6a5f63b1d23a6433b19a3941d');
Vue.use(ba, { siteId: '034386b6a5f63b1d23a6433b19a3941d' }); */
Vue.component('qrcode', VueQrCode);
Vue.config.productionTip = false;
global.Request = Request;

// eslint-disable-next-line
const _hmt = _hmt || [];
// eslint-disable-next-line
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
/* eslint-disable-next-line */
(function () {
  const hm = document.createElement('script');
  if (window.location.host === 'data.scsio.ac.cn') {
    hm.src = 'https://hm.baidu.com/hm.js?034386b6a5f63b1d23a6433b19a3941d';
  } else {
    hm.src = 'https://hm.baidu.com/hm.js?67a5bafbe53b820ca6843ebe29322077';
  }
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
}());

// 全局组件
// Vue.component('vueWaterfallEasy', vueWaterfallEasy);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  interceptors,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js